import React from "react"
import { startCase } from "lodash"
import styles from "./styles.module.scss"
import { UndoIcon } from "./icons"

const Label = ({
  name,
  text,
  subText,
  fieldChanged = false,
  resetFieldChange = () => {},
  style = {},
}) => {
  return (
    <label htmlFor={name} style={style}>
      {text ? text : startCase(name)}
      {fieldChanged ? (
        <button className={styles.undo} onClick={() => resetFieldChange(name)}>
          <UndoIcon />
        </button>
      ) : null}

      {subText ? (
        <p style={{ display: "block", color: "#f50a0a", fontSize: "12px" }}>
          {subText}
        </p>
      ) : null}
    </label>
  )
}

export default Label
